import React, { useState, useEffect } from 'react';
import cl from './PrepodAndAdmin.module.css';
import AdminService from '../../API/AdminService';
import UserService from '../../API/UserService';
import Spinner from '../../components/UI/Spinner/Spinner';
import { FOLDER_PROFILE } from '../../API/API';
import ava from './img/ava.png';
import diamond from './img/16.png';
import rating from './img/rating_3.png';
import tgIcon from './img/tg.png'
import telephomeIcon from './img/telephomeIcon.png'
import logger from '../../utils/logger';
import PageIntro from '../../components/PageIntro/PageIntro';
import {
    IconUser, IconPlus, IconShieldCheck, IconSearch, IconClose, IconRefresh,
    IconAlert, IconTrash, IconFilter, IconEye,
} from '../../components/Icons';

const PrepodAndAdmin = () => {
    // Состояния данных
    const [prepodAdmins, setPrepodAdmins] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Состояния поиска
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState(''); // '', 'read', 'update', 'prepod'

    // Состояния модальных окон
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [createType, setCreateType] = useState('prepod'); // 'prepod' или 'update'
    const [selectedRecord, setSelectedRecord] = useState(null);

    // Состояния формы
    const [formData, setFormData] = useState({
        UserId: null,
        ferstName: '',
        lastName: '',
        phone: '',
        telegram: '',
        status: 'read'
    });

    // Состояния поиска аккаунтов майнкрафтии
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [selectedMinecraftAccount, setSelectedMinecraftAccount] = useState(null);
    const [isSearching, setIsSearching] = useState(false);

    // Состояния для данных майнкрафтии
    const [minecraftProfiles, setMinecraftProfiles] = useState({});

    // Состояния загрузки
    const [isCreating, setIsCreating] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    // Состояния уведомлений
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [notificationStatus, setNotificationStatus] = useState('success');

    // Загрузка данных при монтировании
    useEffect(() => {
        loadData();
    }, []);

    // Поиск с дебаунсом
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (searchQuery.trim() && (showCreateModal || showEditModal)) {
                handleMinecraftSearch();
            } else {
                setSearchResults([]);
            }
        }, 300);
        return () => clearTimeout(timeoutId);
    }, [searchQuery, showCreateModal, showEditModal]);

    // Фильтрация данных
    useEffect(() => {
        filterData();
    }, [searchTerm, statusFilter, prepodAdmins, minecraftProfiles]);

    // Функция показа уведомлений
    const showNotificationMessage = (message, status = 'success') => {
        setNotificationMessage(message);
        setNotificationStatus(status);
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false);
        }, 5000);
    };

    // Загрузка всех данных
    const loadData = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await AdminService.getAllPrepodAdmin();
            const data = response.success ? response.data : [];
            setPrepodAdmins(data);
            await loadMinecraftProfiles(data);
        } catch (error) {
            logger.error('Ошибка загрузки данных:', error);
            setError('Ошибка загрузки данных. Попробуйте обновить страницу.');
        } finally {
            setLoading(false);
        }
    };

    // Загрузка профилей Майнкрафтии одним bulk-запросом.
    const loadMinecraftProfiles = async (data) => {
        const ids = (data || []).map(i => i.UserId).filter(Boolean);
        if (ids.length === 0) {
            setMinecraftProfiles({});
            return;
        }
        const profiles = await UserService.getProfilesBulk(ids);
        setMinecraftProfiles(profiles);
    };

    // Фильтрация данных
    const filterData = () => {
        let filtered = [...prepodAdmins];

        // Фильтр по поисковому запросу
        if (searchTerm) {
            const searchLower = searchTerm.toLowerCase();
            filtered = filtered.filter(item => {
                const profile = minecraftProfiles[item.UserId];
                return (
                    item.ferstName?.toLowerCase().includes(searchLower) ||
                    item.lastName?.toLowerCase().includes(searchLower) ||
                    item.phone?.toLowerCase().includes(searchLower) ||
                    item.telegram?.toLowerCase().includes(searchLower) ||
                    profile?.firstName?.toLowerCase().includes(searchLower) ||
                    getStatusText(item.status).toLowerCase().includes(searchLower)
                );
            });
        }

        // Фильтр по статусу
        if (statusFilter) {
            filtered = filtered.filter(item => item.status === statusFilter);
        }

        setFilteredData(filtered);
    };

    // Получить текст статуса
    const getStatusText = (status) => {
        switch (status) {
            case 'read': return 'Только чтение';
            case 'update': return 'Администратор';
            case 'prepod': return 'Преподаватель';
            default: return status;
        }
    };

    // Получить цвет статуса
    const getStatusColor = (status) => {
        switch (status) {
            case 'read': return '#6b7280';
            case 'update': return '#dc2626';
            case 'prepod': return '#059669';
            default: return '#6b7280';
        }
    };

    // Поиск аккаунтов майнкрафтии
    const handleMinecraftSearch = async () => {
        if (!searchQuery.trim()) {
            setSearchResults([]);
            return;
        }

        setIsSearching(true);
        try {
            const response = await UserService.searchUsers(searchQuery);
            const usersWithData = await Promise.all(
                response.data.map(async (user) => {
                    try {
                        const profileData = await UserService.getProfileData(user.id);
                        return {
                            ...user,
                            diamond: profileData.diamond || 0,
                            rating: profileData.rating || 0
                        };
                    } catch (error) {
                        return { ...user, diamond: 0, rating: 0 };
                    }
                })
            );
            setSearchResults(usersWithData);
        } catch (error) {
            logger.error('Ошибка поиска пользователей:', error);
            setSearchResults([]);
        } finally {
            setIsSearching(false);
        }
    };

    // Открыть модалку создания
    const openCreateModal = (type) => {
        setCreateType(type);
        setFormData({
            UserId: null,
            ferstName: '',
            lastName: '',
            phone: '',
            telegram: '',
            status: type === 'prepod' ? 'prepod' : 'update'
        });
        setSelectedMinecraftAccount(null);
        setSearchQuery('');
        setSearchResults([]);
        setShowCreateModal(true);
    };

    // Открыть модалку редактирования
    const openEditModal = (record) => {
        setSelectedRecord(record);
        setFormData({
            UserId: record.UserId,
            ferstName: record.ferstName || '',
            lastName: record.lastName || '',
            phone: record.phone || '',
            telegram: record.telegram || '',
            status: record.status
        });
        setSelectedMinecraftAccount(minecraftProfiles[record.UserId] ? {
            id: record.UserId,
            ...minecraftProfiles[record.UserId]
        } : null);
        setSearchQuery('');
        setSearchResults([]);
        setShowEditModal(true);
    };

    // Открыть модалку удаления
    const openDeleteModal = (record) => {
        setSelectedRecord(record);
        setShowDeleteModal(true);
    };

    // Закрыть все модалки
    const closeAllModals = () => {
        setShowCreateModal(false);
        setShowEditModal(false);
        setShowDeleteModal(false);
        setSelectedRecord(null);
        setFormData({
            UserId: null,
            ferstName: '',
            lastName: '',
            phone: '',
            telegram: '',
            status: 'read'
        });
        setSelectedMinecraftAccount(null);
        setSearchQuery('');
        setSearchResults([]);
    };

    // Выбор аккаунта майнкрафтии
    const selectMinecraftAccount = (account) => {
        setSelectedMinecraftAccount(account);
        setFormData(prev => ({ ...prev, UserId: account.id }));
        setSearchResults([]);
        setSearchQuery('');
    };

    // Изменение полей формы
    const handleFormChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    // Создание записи
    const handleCreate = async () => {
        if (!selectedMinecraftAccount) {
            showNotificationMessage('Выберите аккаунт из Майнкрафтии', 'error');
            return;
        }

        // Проверка на существование аккаунта
        const existing = prepodAdmins.find(item => item.UserId === selectedMinecraftAccount.id);
        if (existing) {
            showNotificationMessage('Этот аккаунт уже добавлен', 'error');
            return;
        }

        setIsCreating(true);
        try {
            const response = await AdminService.createPrepodAdmin(formData);
            if (response.success) {
                closeAllModals();
                showNotificationMessage(`${getStatusText(formData.status)} успешно добавлен!`, 'success');
                await loadData();
            } else {
                showNotificationMessage('Ошибка при создании: ' + (response.error || 'Неизвестная ошибка'), 'error');
            }
        } catch (error) {
            logger.error('Ошибка создания:', error);
            showNotificationMessage('Ошибка при создании. Попробуйте еще раз.', 'error');
        } finally {
            setIsCreating(false);
        }
    };

    // Обновление записи
    const handleUpdate = async () => {
        if (!selectedMinecraftAccount) {
            showNotificationMessage('Выберите аккаунт из Майнкрафтии', 'error');
            return;
        }

        setIsUpdating(true);
        try {
            const response = await AdminService.updatePrepodAdmin(selectedRecord.id, formData);
            if (response.success) {
                closeAllModals();
                showNotificationMessage('Данные успешно обновлены!', 'success');
                await loadData();
            } else {
                showNotificationMessage('Ошибка при обновлении: ' + (response.error || 'Неизвестная ошибка'), 'error');
            }
        } catch (error) {
            logger.error('Ошибка обновления:', error);
            showNotificationMessage('Ошибка при обновлении. Попробуйте еще раз.', 'error');
        } finally {
            setIsUpdating(false);
        }
    };

    // Удаление записи
    const handleDelete = async () => {
        setIsDeleting(true);
        try {
            const response = await AdminService.deletePrepodAdmin(selectedRecord.id);
            if (response.success) {
                closeAllModals();
                showNotificationMessage('Запись успешно удалена!', 'success');
                await loadData();
            } else {
                showNotificationMessage('Ошибка при удалении: ' + (response.error || 'Неизвестная ошибка'), 'error');
            }
        } catch (error) {
            logger.error('Ошибка удаления:', error);
            showNotificationMessage('Ошибка при удалении. Попробуйте еще раз.', 'error');
        } finally {
            setIsDeleting(false);
        }
    };

    if (loading) {
        return (
            <div className={cl.page_wrapper}>
                <Spinner size="large" text="Загрузка преподавателей" fullPage />
            </div>
        );
    }

    if (error) {
        return (
            <div className={cl.page_wrapper}>
                <div className={cl.wrap_content_1}>
                    <div className={cl.error}>
                        <h3>Ошибка загрузки</h3>
                        <p>{error}</p>
                        <button onClick={loadData} className={cl.retryButton}>
                            Попробовать снова
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Счётчики по ролям
    const countByStatus = (status) => prepodAdmins.filter(i => i.status === status).length;
    const prepodCount = countByStatus('prepod');
    const adminCount = countByStatus('update');
    const readCount = countByStatus('read');

    return (
        <div className={cl.page_wrapper}>
            <div className={cl.wrap_content_1}>
                {/* Уведомления */}
                {showNotification && (
                    <div className={`${cl.notificationV2} ${notificationStatus === 'success' ? cl.notificationSuccess : cl.notificationError}`}>
                        <span className={cl.notificationIconV2}>
                            {notificationStatus === 'success'
                                ? <IconShieldCheck width={16} height={16}/>
                                : <IconAlert width={16} height={16}/>}
                        </span>
                        <span className={cl.notificationMessage}>{notificationMessage}</span>
                        <button
                            onClick={() => setShowNotification(false)}
                            className={cl.notificationCloseV2}
                            aria-label="Закрыть"
                        >
                            <IconClose width={14} height={14}/>
                        </button>
                    </div>
                )}

                {/* Шапка-карточка */}
                <div className={cl.pageHeaderV2}>
                    <div className={cl.pageHeaderLeft}>
                        <div className={cl.pageHeaderIcon}>
                            <IconUser width={22} height={22}/>
                        </div>
                        <div className={cl.pageHeaderText}>
                            <div className={cl.pageHeaderTopRow}>
                                <h1 className={cl.pageHeaderTitle}>Преподаватели и администраторы</h1>
                                <span className={cl.pageHeaderPill}>
                                    <span className={cl.pageHeaderPillStrong}>{prepodAdmins.length}</span>
                                    <span className={cl.pageHeaderPillMuted}>всего</span>
                                </span>
                                {prepodCount > 0 && (
                                    <span className={`${cl.pageHeaderPill} ${cl.pageHeaderPillPrepod}`}>
                                        <span className={cl.pageHeaderPillStrong}>{prepodCount}</span>
                                        <span className={cl.pageHeaderPillMuted}>препод.</span>
                                    </span>
                                )}
                                {adminCount > 0 && (
                                    <span className={`${cl.pageHeaderPill} ${cl.pageHeaderPillAdmin}`}>
                                        <span className={cl.pageHeaderPillStrong}>{adminCount}</span>
                                        <span className={cl.pageHeaderPillMuted}>админ.</span>
                                    </span>
                                )}
                                {readCount > 0 && (
                                    <span className={cl.pageHeaderPill}>
                                        <span className={cl.pageHeaderPillStrong}>{readCount}</span>
                                        <span className={cl.pageHeaderPillMuted}>чтение</span>
                                    </span>
                                )}
                            </div>
                            <div className={cl.breadcrumbs}>
                                АдминПанель · Аккаунты · Управление доступом
                            </div>
                        </div>
                    </div>
                    <div className={cl.pageHeaderActions}>
                        <button
                            onClick={loadData}
                            className={cl.btnGhostV2}
                            title="Обновить"
                        >
                            <IconRefresh width={15} height={15}/>
                        </button>
                        <button
                            onClick={() => openCreateModal('admin')}
                            className={cl.btnSecondaryV2}
                        >
                            <IconShieldCheck width={15} height={15}/>
                            <span>Администратор</span>
                        </button>
                        <button
                            onClick={() => openCreateModal('prepod')}
                            className={cl.btnPrimaryV2}
                        >
                            <IconPlus width={16} height={16}/>
                            <span>Преподаватель</span>
                        </button>
                    </div>
                </div>

                <PageIntro
                    storageKey="prepod-admin"
                    title="О странице «Преподаватели и админы»"
                    text="Здесь вы назначаете, кто и с какими правами имеет доступ к админ-панели вашего центра. Пользователь должен сначала зарегистрироваться в Майнкрафтии — после этого вы привязываете его аккаунт к одной из ролей."
                    bullets={[
                        'Преподаватель — журнал своих курсов и проверка проектов учеников',
                        'Администратор — полный доступ к админ-панели наравне с руководителем',
                        '«Только чтение» — просмотр без права что-то менять',
                        'Один и тот же аккаунт Майнкрафтии нельзя привязать дважды',
                    ]}
                />

                {/* Поиск и фильтры */}
                <div className={cl.searchAndFiltersV2}>
                    <div className={cl.searchContainerV2}>
                        <span className={cl.searchIconV2}>
                            <IconSearch width={18} height={18}/>
                        </span>
                        <input
                            type="text"
                            placeholder="Поиск по имени, фамилии, телефону, телеграм…"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className={cl.searchInputV2}
                        />
                        {searchTerm && (
                            <button
                                className={cl.clearSearchV2}
                                onClick={() => setSearchTerm('')}
                                aria-label="Очистить"
                            >
                                <IconClose width={14} height={14}/>
                            </button>
                        )}
                    </div>
                    <div className={cl.filterContainerV2}>
                        <span className={cl.filterIconV2}>
                            <IconFilter width={16} height={16}/>
                        </span>
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            className={cl.filterSelectV2}
                        >
                            <option value="">Все роли</option>
                            <option value="prepod">Преподаватели</option>
                            <option value="update">Администраторы</option>
                            <option value="read">Только чтение</option>
                        </select>
                    </div>
                </div>

                {/* Список записей */}
                <div className={cl.recordsList}>
                    {filteredData.length === 0 ? (
                        <div className={cl.noData}>
                            <h3>Нет данных</h3>
                            <p>
                                {searchTerm || statusFilter 
                                    ? 'По вашему запросу ничего не найдено' 
                                    : 'Добавьте первого преподавателя или администратора'
                                }
                            </p>
                        </div>
                    ) : (
                        filteredData.map(record => {
                            const profile = minecraftProfiles[record.UserId];
                            const roleIcon = record.status === 'update'
                                ? <IconShieldCheck width={12} height={12}/>
                                : record.status === 'prepod'
                                    ? <IconUser width={12} height={12}/>
                                    : <IconEye width={12} height={12}/>;
                            return (
                                <div
                                    key={record.id}
                                    className={`${cl.recordCard} ${cl[`recordCardRole_${record.status}`] || ''}`}
                                    onClick={() => openEditModal(record)}
                                >
                                    {/* Информация о пользователе */}
                                    <div className={cl.recordHeader}>
                                        <div className={cl.recordMainInfo}>
                                            <div className={cl.recordName}>
                                                {record.ferstName || record.lastName
                                                    ? `${record.ferstName} ${record.lastName}`.trim()
                                                    : 'Имя не указано'
                                                }
                                            </div>
                                            <div className={`${cl.roleBadge} ${cl[`roleBadge_${record.status}`] || ''}`}>
                                                {roleIcon}
                                                <span>{getStatusText(record.status)}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Контактная информация */}
                                    {(record.phone || record.telegram) && (
                                        <div className={cl.recordContacts}>
                                            {record.phone && (
                                                <div className={cl.contactItem}>
                                                    
                                                    <img style={{width:20,height:20}} src={telephomeIcon} alt="" />
                                                    <p style={{margin:'2px 0 0 4px'}}>{record.phone}</p>
                                                </div>
                                            )}
                                            {record.telegram && (
                                                <div className={cl.contactItem}>
                                                    <img style={{width:20,height:20}} src={tgIcon} alt="" />
                                                    <p style={{margin:'2px 0 0 4px'}}>{record.telegram}</p>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Информация об аккаунте майнкрафтии */}
                                    <div className={cl.minecraftInfo}>
                                        {profile ? (
                                            <div className={cl.minecraftProfile}>
                                                <img 
                                                    src={`${FOLDER_PROFILE}${profile.idUser}.png`}
                                                    alt={profile.firstName}
                                                    className={cl.minecraftAvatar}
                                                    onError={(e) => {
                                                        e.target.src = ava;
                                                    }}
                                                />
                                                <div className={cl.minecraftDetails}>
                                                    <div className={cl.minecraftName}>
                                                        {profile.firstName}
                                                    </div>
                                                    <div className={cl.minecraftLevel}>
                                                        Уровень {profile.level}
                                                    </div>
                                                </div>
                                                <div className={cl.minecraftStats}>
                                                    <div className={cl.minecraftStat}>
                                                        <img src={diamond} alt="Алмазы" />
                                                        {profile.diamond}
                                                    </div>
                                                    <div className={cl.minecraftStat}>
                                                        <img style={{width:24}} src={rating} alt="Рейтинг" />
                                                        {profile.rating}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={cl.minecraftError}>
                                                <IconAlert width={14} height={14}/>
                                                <span>Ошибка загрузки профиля Майнкрафтии</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                {/* Модалка создания */}
                {showCreateModal && (
                    <div className={cl.modalOverlay} onClick={closeAllModals}>
                        <div className={cl.modalContent} onClick={e => e.stopPropagation()}>
                            <div className={cl.modalHeader}>
                                <div className={cl.modalTitleWrap}>
                                    <span className={cl.modalTitleIcon}>
                                        {createType === 'prepod'
                                            ? <IconUser width={18} height={18}/>
                                            : <IconShieldCheck width={18} height={18}/>}
                                    </span>
                                    <h2>
                                        Добавить {createType === 'prepod' ? 'преподавателя' : 'администратора'}
                                    </h2>
                                </div>
                                <button
                                    onClick={closeAllModals}
                                    className={cl.closeButton}
                                    aria-label="Закрыть"
                                >
                                    <IconClose width={18} height={18}/>
                                </button>
                            </div>

                            <div className={cl.modalBody}>
                                {/* Поиск аккаунта майнкрафтии */}
                                <div className={cl.formGroup}>
                                    <label>Аккаунт из Майнкрафтии *</label>
                                    <div className={cl.minecraftSearch}>
                                        <input
                                            type="text"
                                            placeholder="Введите имя пользователя"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className={cl.formInput}
                                        />
                                        {isSearching && (
                                            <div className={cl.searchingIndicator}>
                                                Поиск...
                                            </div>
                                        )}
                                        {searchResults.length > 0 && (
                                            <div className={cl.searchResults}>
                                                {searchResults.map(user => (
                                                    <div 
                                                        key={user.id}
                                                        className={`${cl.searchResultItem} ${selectedMinecraftAccount?.id === user.id ? cl.selected : ''}`}
                                                        onClick={() => selectMinecraftAccount(user)}
                                                    >
                                                        <img 
                                                            src={`${FOLDER_PROFILE}${user.idUser}.png`}
                                                            alt={user.firstName}
                                                            className={cl.searchResultAvatar}
                                                            onError={(e) => {
                                                                e.target.src = ava;
                                                            }}
                                                        />
                                                        <div className={cl.searchResultInfo}>
                                                            <div className={cl.searchResultName}>
                                                                {user.firstName}
                                                            </div>
                                                            <div className={cl.searchResultStats}>
                                                                Уровень {user.level}
                                                                <span className={cl.statSep}>·</span>
                                                                <img src={diamond} alt="" className={cl.statInlineIcon}/>
                                                                {user.diamond}
                                                                <span className={cl.statSep}>·</span>
                                                                <img src={rating} alt="" className={cl.statInlineIcon}/>
                                                                {user.rating}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {searchQuery && searchResults.length === 0 && !isSearching && (
                                            <div className={cl.noSearchResults}>
                                                Пользователи не найдены
                                            </div>
                                        )}
                                    </div>

                                    {/* Выбранный аккаунт */}
                                    {selectedMinecraftAccount && (
                                        <div className={cl.selectedAccount}>
                                            <img 
                                                src={`${FOLDER_PROFILE}${selectedMinecraftAccount.idUser}.png`}
                                                alt={selectedMinecraftAccount.firstName}
                                                className={cl.selectedAvatar}
                                                onError={(e) => {
                                                    e.target.src = ava;
                                                }}
                                            />
                                            <div className={cl.selectedInfo}>
                                                <div className={cl.selectedName}>
                                                    {selectedMinecraftAccount.firstName}
                                                </div>
                                                <div className={cl.selectedStats}>
                                                    Уровень {selectedMinecraftAccount.level}
                                                    <span className={cl.statSep}>·</span>
                                                    <img src={diamond} alt="" className={cl.statInlineIcon}/>
                                                    {selectedMinecraftAccount.diamond}
                                                    <span className={cl.statSep}>·</span>
                                                    <img src={rating} alt="" className={cl.statInlineIcon}/>
                                                    {selectedMinecraftAccount.rating}
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => setSelectedMinecraftAccount(null)}
                                                className={cl.removeSelection}
                                                aria-label="Снять выбор"
                                            >
                                                <IconClose width={14} height={14}/>
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Личная информация */}
                                <div className={cl.formRow}>
                                    <div className={cl.formGroup}>
                                        <label>Имя</label>
                                        <input
                                            type="text"
                                            value={formData.ferstName}
                                            onChange={(e) => handleFormChange('ferstName', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="Введите имя"
                                        />
                                    </div>
                                    <div className={cl.formGroup}>
                                        <label>Фамилия</label>
                                        <input
                                            type="text"
                                            value={formData.lastName}
                                            onChange={(e) => handleFormChange('lastName', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="Введите фамилию"
                                        />
                                    </div>
                                </div>

                                <div className={cl.formRow}>
                                    <div className={cl.formGroup}>
                                        <label>Телефон</label>
                                        <input
                                            type="tel"
                                            value={formData.phone}
                                            onChange={(e) => handleFormChange('phone', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="+7 (xxx) xxx-xx-xx"
                                        />
                                    </div>
                                    <div className={cl.formGroup}>
                                        <label>Телеграм</label>
                                        <input
                                            type="text"
                                            value={formData.telegram}
                                            onChange={(e) => handleFormChange('telegram', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="@username или https://t.me/username"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={cl.modalActions}>
                                <button 
                                    onClick={closeAllModals}
                                    className={cl.cancelButton}
                                    disabled={isCreating}
                                >
                                    Отмена
                                </button>
                                <button 
                                    onClick={handleCreate}
                                    className={cl.submitButton}
                                    disabled={isCreating || !selectedMinecraftAccount}
                                >
                                    {isCreating ? 'Создание...' : 'Создать'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Модалка редактирования */}
                {showEditModal && (
                    <div className={cl.modalOverlay} onClick={closeAllModals}>
                        <div className={cl.modalContent} onClick={e => e.stopPropagation()}>
                            <div className={cl.modalHeader}>
                                <div className={cl.modalTitleWrap}>
                                    <span className={cl.modalTitleIcon}>
                                        <IconUser width={18} height={18}/>
                                    </span>
                                    <h2>Редактировать данные</h2>
                                </div>
                                <button
                                    onClick={closeAllModals}
                                    className={cl.closeButton}
                                    aria-label="Закрыть"
                                >
                                    <IconClose width={18} height={18}/>
                                </button>
                            </div>

                            <div className={cl.modalBody}>
                                {/* Смена аккаунта майнкрафтии */}
                                <div className={cl.formGroup}>
                                    <label>Аккаунт из Майнкрафтии *</label>
                                    <div className={cl.minecraftSearch}>
                                        <input
                                            type="text"
                                            placeholder="Введите имя пользователя для смены"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className={cl.formInput}
                                        />
                                        {isSearching && (
                                            <div className={cl.searchingIndicator}>
                                                Поиск...
                                            </div>
                                        )}
                                        {searchResults.length > 0 && (
                                            <div className={cl.searchResults}>
                                                {searchResults.map(user => (
                                                    <div 
                                                        key={user.id}
                                                        className={`${cl.searchResultItem} ${selectedMinecraftAccount?.id === user.id ? cl.selected : ''}`}
                                                        onClick={() => selectMinecraftAccount(user)}
                                                    >
                                                        <img 
                                                            src={`${FOLDER_PROFILE}${user.idUser}.png`}
                                                            alt={user.firstName}
                                                            className={cl.searchResultAvatar}
                                                            onError={(e) => {
                                                                e.target.src = ava;
                                                            }}
                                                        />
                                                        <div className={cl.searchResultInfo}>
                                                            <div className={cl.searchResultName}>
                                                                {user.firstName}
                                                            </div>
                                                            <div className={cl.searchResultStats}>
                                                                Уровень {user.level}
                                                                <span className={cl.statSep}>·</span>
                                                                <img src={diamond} alt="" className={cl.statInlineIcon}/>
                                                                {user.diamond}
                                                                <span className={cl.statSep}>·</span>
                                                                <img src={rating} alt="" className={cl.statInlineIcon}/>
                                                                {user.rating}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {/* Текущий выбранный аккаунт */}
                                    {selectedMinecraftAccount && (
                                        <div className={cl.selectedAccount}>
                                            <img 
                                                src={`${FOLDER_PROFILE}${selectedMinecraftAccount.idUser}.png`}
                                                alt={selectedMinecraftAccount.firstName}
                                                className={cl.selectedAvatar}
                                                onError={(e) => {
                                                    e.target.src = ava;
                                                }}
                                            />
                                            <div className={cl.selectedInfo}>
                                                <div className={cl.selectedName}>
                                                    {selectedMinecraftAccount.firstName}
                                                </div>
                                                <div className={cl.selectedStats}>
                                                    Уровень {selectedMinecraftAccount.level}
                                                    <span className={cl.statSep}>·</span>
                                                    <img src={diamond} alt="" className={cl.statInlineIcon}/>
                                                    {selectedMinecraftAccount.diamond}
                                                    <span className={cl.statSep}>·</span>
                                                    <img src={rating} alt="" className={cl.statInlineIcon}/>
                                                    {selectedMinecraftAccount.rating}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Роль */}
                                <div className={cl.formGroup}>
                                    <label>Роль *</label>
                                    <select
                                        value={formData.status}
                                        onChange={(e) => handleFormChange('status', e.target.value)}
                                        className={cl.formSelect}
                                    >
                                        <option value="read">Только чтение</option>
                                        <option value="prepod">Преподаватель</option>
                                        <option value="update">Администратор</option>
                                    </select>
                                </div>

                                {/* Личная информация */}
                                <div className={cl.formRow}>
                                    <div className={cl.formGroup}>
                                        <label>Имя</label>
                                        <input
                                            type="text"
                                            value={formData.ferstName}
                                            onChange={(e) => handleFormChange('ferstName', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="Введите имя"
                                        />
                                    </div>
                                    <div className={cl.formGroup}>
                                        <label>Фамилия</label>
                                        <input
                                            type="text"
                                            value={formData.lastName}
                                            onChange={(e) => handleFormChange('lastName', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="Введите фамилию"
                                        />
                                    </div>
                                </div>

                                <div className={cl.formRow}>
                                    <div className={cl.formGroup}>
                                        <label>Телефон</label>
                                        <input
                                            type="tel"
                                            value={formData.phone}
                                            onChange={(e) => handleFormChange('phone', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="+7 (xxx) xxx-xx-xx"
                                        />
                                    </div>
                                    <div className={cl.formGroup}>
                                        <label>Телеграм</label>
                                        <input
                                            type="text"
                                            value={formData.telegram}
                                            onChange={(e) => handleFormChange('telegram', e.target.value)}
                                            className={cl.formInput}
                                            placeholder="@username или https://t.me/username"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={cl.modalActions}>
                                <button
                                    onClick={() => openDeleteModal(selectedRecord)}
                                    className={cl.deleteButton}
                                    disabled={isUpdating}
                                >
                                    <IconTrash width={14} height={14}/>
                                    <span>Удалить</span>
                                </button>
                                <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                                    <button
                                        onClick={closeAllModals}
                                        className={cl.cancelButton}
                                        disabled={isUpdating}
                                    >
                                        Отмена
                                    </button>
                                    <button
                                        onClick={handleUpdate}
                                        className={cl.submitButton}
                                        disabled={isUpdating || !selectedMinecraftAccount}
                                    >
                                        {isUpdating ? 'Сохранение…' : 'Сохранить'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Модалка подтверждения удаления */}
                {showDeleteModal && (
                    <div className={cl.modalOverlay} onClick={() => setShowDeleteModal(false)}>
                        <div className={cl.deleteModalContent} onClick={e => e.stopPropagation()}>
                            <div className={cl.deleteModalHeader}>
                                <div className={cl.modalTitleWrap}>
                                    <span className={`${cl.modalTitleIcon} ${cl.modalTitleIconDanger}`}>
                                        <IconAlert width={18} height={18}/>
                                    </span>
                                    <h3>Подтверждение удаления</h3>
                                </div>
                                <button
                                    onClick={() => setShowDeleteModal(false)}
                                    className={cl.deleteModalClose}
                                    aria-label="Закрыть"
                                >
                                    <IconClose width={18} height={18}/>
                                </button>
                            </div>
                            <div className={cl.deleteModalBody}>
                                <p className={cl.confirmText}>
                                    Вы точно хотите удалить запись{' '}
                                    <strong>«{selectedRecord?.ferstName} {selectedRecord?.lastName}»</strong>{' '}
                                    ({getStatusText(selectedRecord?.status)})?
                                </p>
                                <p className={cl.confirmHint}>
                                    Это действие нельзя отменить.
                                </p>
                            </div>
                            <div className={cl.deleteModalActions}>
                                <button
                                    onClick={() => setShowDeleteModal(false)}
                                    className={cl.cancelDeleteButton}
                                    disabled={isDeleting}
                                >
                                    Отмена
                                </button>
                                <button
                                    onClick={handleDelete}
                                    className={cl.confirmDeleteButton}
                                    disabled={isDeleting}
                                >
                                    {isDeleting ? 'Удаление…' : 'Да, удалить'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PrepodAndAdmin;